
export default {
  name: "ImpactExchangeRateSection",

  data() {
    return ({
      exchange_data: {
        kicker: "The Impact Exchange Rate",
        title: "Buying Outcomes, Not Promises",
        description:
          "We eliminate ambiguity. We have a standardized Exchange Rate for doing good. You know exactly what your capital 'buys' in social terms.",
      },

      calculator_data: {
        kicker: "Impact Calculator",
        amount_label: "Investment Amount",
        amount_value: "R1,000,000",
        footnote: "VSSIN = Vbase + Impact Metric + Profit Share",
      },

      calculator_rows: [
        { key: "jobs", label: "Verified Jobs", value: "1,000" },
        { key: "bonus", label: "Inclusion Bonus", value: "+ R200,000" },
        { key: "growth", label: "Revenue Growth", value: "+ R100,000" },
      ],
    });
  },
};
